<template>
    <div>
        <q-input
            v-model="filter"
            dense outlined
            placeholder="Buscar icono..."
            clearable
            class="q-mb-sm"
        >
            <template v-slot:prepend>
                <q-icon name="search" size="xs" />
            </template>
        </q-input>
        <q-icon-picker
            :model-value="modelValue"
            @update:model-value="$emit('update:modelValue', $event)"
            v-model:model-pagination="pagination"
            :icons="icons"
            :filter="filter"
            :style="{ height: height }"
        />
    </div>
</template>

<script>
import { QIconPicker } from '@quasar/quasar-ui-qiconpicker'
import materialIconSet from '@quasar/quasar-ui-qiconpicker/src/components/icon-set/material-icons.js'

const loadedIcons = materialIconSet.default?.icons || materialIconSet.icons || []

export default {
    name: 'IconPicker',
    components: { QIconPicker },
    props: {
        modelValue: { type: String, default: null },
        height: { type: String, default: '220px' },
    },
    emits: ['update:modelValue'],
    data: () => ({
        filter: '',
        pagination: { itemsPerPage: 25, page: 0 },
        icons: loadedIcons,
    }),
}
</script>